import Vue from 'vue';
import VueRouter from 'vue-router';
import store from "./store";
import {initOnRouteChange} from "./bootstrap";
import PageNotFound from "./components/includes/PageNotFound";

import Header from "./components/includes/Header";
import FooterMenu from "./components/includes/FooterMenu";
// 💥 Lazy Loading
// https://vueschool.io/lessons/how-to-lazy-load-routes-with-vue-router?friend=vuerouter
const Accueil = () => import(/* webpackChunkName: "accueil" */ "./components/accueil/Accueil");
const Login = () => import(/* webpackChunkName: "login" */ './components/auth/Login');
const Register = () => import(/* webpackChunkName: "login" */ './components/auth/Register');
const PasswordReset = () => import(/* webpackChunkName: "login" */ './components/auth/PasswordReset');
const PasswordForgotten = () => import(/* webpackChunkName: "login" */ './components/auth/PasswordForgotten');
const Panier = () => import(/* webpackChunkName: "panier" */ './components/panier/Panier');
const PanierOffCanvas = () => import(/* webpackChunkName: "panier" */ "./components/panier/PanierOffCanvas");
const Compte = () => import(/* webpackChunkName: "compte" */ "./components/compte/Compte");
const CommandesListe = () => import(/* webpackChunkName: "compte" */ './components/compte/commandes/CommandesListe');
const CommandesSingle = () => import(/* webpackChunkName: "compte" */ './components/compte/commandes/CommandesSingle');
const Produits = () => import(/* webpackChunkName: "produit" */ './components/produits/Produits');
const ProduitsListOffCanvas = () => import(/* webpackChunkName: "produit" */ './components/produits/includes/liste/ProduitsListOffCanvas');
const ProduitSingle = () => import(/* webpackChunkName: "produit" */ "./components/produits/includes/single/ProduitSingle");
const ProduitSingleOffCanvas = () => import(/* webpackChunkName: "produit" */ "./components/produits/includes/single/ProduitSingleOffCanvas");



Vue.use(VueRouter);

const routes = [
    {
        path: `/`,
        name: 'accueil',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: Accueil
        }
    },
    {
        path: `/login`,
        name: 'login',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: Login
        }
    },
    {
        path: `/register`,
        name: 'register',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: Register
        }
    },
    {
        path: `/password/forgotten`,
        name: 'password.forgotten',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: PasswordForgotten
        }
    },
    {
        path: `/password/reset/:token`,
        name: 'password.reset',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: PasswordReset
        }
    },
    {
        path: `/produits/:slug?`,
        name: 'produits',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: Produits,
            offCanvas: ProduitsListOffCanvas
        }
    },
    {
        path: `/produit/:id`,
        name: 'produit.single',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: ProduitSingle,
            offCanvas: ProduitSingleOffCanvas
        },
        beforeEnter: async (to, from, next) => {
            // Probleme si on arrive directement ici, les autres produits n'existent pas encore

            const produitExiste = (await axios.get(`/api/produits/${to.params.id}`)).data.data;
            if (!produitExiste) {
                next({name: 'produits'})
            } else {
                await store.dispatch('produits/setOpenedProduit', to.params.id);
                next()
            }
        }
    },
    {
        path: `/panier`,
        name: 'panier',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: Panier,
            offCanvas: PanierOffCanvas
        }
    },
    {
        path: `/compte`,
        name: 'compte',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: Compte
        },
        meta: {requiresAuth: true},
    },
    {
        path: `/compte/commandes/:id_commande`,
        name: 'compte.commandes.single',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: CommandesSingle
        },
        meta: {requiresAuth: true},
        beforeEnter: async (to, from, next) => {
            // ✅ Vérifier que la commande existe bien, et qu'elle appartient bien au client
            const commande = (await axios.get(`/api/commandes/${to.params.id_commande}`)).data.data;
            const isAuthenticated = store.state.auth.authenticated;
            // Aucune commande
            if (commande && isAuthenticated && store.state.auth.user.id === commande.user_id) {
                next();
            } else {
                next({name: 'accueil'});
            }
        }
    },
    {
        path: `/compte/commandes`,
        name: 'compte.commandes',
        components: {
            header: Header,
            footerMenu: FooterMenu,
            content: CommandesListe
        },
        meta: {requiresAuth: true},
    },
    // Pour toutes les autres pages qui n'existent pas on redirige vers l'accueil (= 404)
    {
        path: '*',
        components: {
            content: PageNotFound,
            rightSidebar: null
        },
        name: 'page-not-found'
    },
];

export const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeResolve((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth) && to.name !== 'login') {
        const isAuthenticated = store.state.auth.authenticated
        if (!isAuthenticated) {
            next({
                name: 'login',
                query: {redirect: to.fullPath},
                force: true
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

router.afterEach((to, from) => {
    setTimeout(initOnRouteChange, 0) // appelé en dernier
})
